import { createSlice } from "@reduxjs/toolkit";

const initialUIState = { showDrawer: false };

const uiSlice = createSlice({
  name: "theme",
  initialState: initialUIState,
  reducers: {
    toggleDrawer(state) {
      state.showDrawer = !state.showDrawer;
    },
    setShowDrawer(state,action){
        state.showDrawer = action.payload
    }
  },
});


export default uiSlice.reducer;
export const uiActions = uiSlice.actions;
